export function initializeApiLogger() {
  const originalFetch = window.fetch;

  const fetchWrapper = async function (...args: Parameters<typeof fetch>): Promise<Response> {
    try {
      const response = await originalFetch(...args);
      
      // Specifically catch 503 Service Unavailable errors
      if (response.status === 503) {
        const url = (typeof args[0] === 'string' ? args[0] : args[0] instanceof Request ? args[0].url : 'Unknown URL');
        
        // Report to monitoring endpoint asynchronously
        originalFetch('/api/log-client-error', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            level: 'error',
            message: `API HTTP 503 Service Unavailable`,
            url: url,
            status: response.status,
            userAgent: navigator.userAgent,
            timestamp: new Date().toISOString()
          })
        }).catch(err => console.error('Failed to report 503 error:', err));
      }
      
      return response;
    } catch (error) {
      // Also catch network failures that might be related to infrastructure limits
      const url = (typeof args[0] === 'string' ? args[0] : args[0] instanceof Request ? args[0].url : 'Unknown URL');
      
      originalFetch('/api/log-client-error', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          level: 'fatal',
          message: error instanceof Error ? error.message : 'Unknown network error',
          url: url,
          userAgent: navigator.userAgent,
          timestamp: new Date().toISOString()
        })
      }).catch(err => console.error('Failed to report network error:', err));
      
      throw error;
    }
  };

  try {
    Object.defineProperty(window, 'fetch', {
      value: fetchWrapper,
      configurable: true,
      writable: true
    });
  } catch (e) {
    console.warn("Could not patch window.fetch", e);
  }
}
